<script setup lang="ts">
import { GripVertical } from '@lucide/vue'

import type { DropdownChecklistData } from './types'

import { DropdownMenuCheckboxItem, DropdownMenuRadioItem } from '@ds/primitives/dropdown-menu'

type Props = {
  item: DropdownChecklistData
  checked?: boolean
  singleSelect?: boolean
  showHandle?: boolean
  readonly?: boolean
}

const { item, checked = false, singleSelect = false, showHandle = false, readonly = false } = defineProps<Props>()

type Emits = {
  'update:checked': [value: boolean]
}

const emit = defineEmits<Emits>()
</script>

<template>
  <DropdownMenuRadioItem
    v-if="singleSelect"
    :value="item.value ?? ''"
    :disabled="item.disabled || readonly"
  >
    <span class="truncate">{{ item.label }}</span>
  </DropdownMenuRadioItem>
  <DropdownMenuCheckboxItem
    v-else
    :model-value="checked"
    :disabled="item.disabled || readonly"
    :class="showHandle ? 'pr-7' : ''"
    @update:model-value="emit('update:checked', $event)"
    @select="(event: Event) => event.preventDefault()"
  >
    <span class="truncate">{{ item.label }}</span>
    <GripVertical
      v-if="showHandle"
      class="handle absolute right-2 size-3.5 shrink-0 cursor-grab text-muted-foreground/60 hover:text-muted-foreground pointer-events-auto"
    />
  </DropdownMenuCheckboxItem>
</template>
